import { render, staticRenderFns } from "./SocialLogin.vue?vue&type=template&id=97e90564&scoped=true"
import script from "./SocialLogin.vue?vue&type=script&lang=js"
export * from "./SocialLogin.vue?vue&type=script&lang=js"
import style0 from "./SocialLogin.vue?vue&type=style&index=0&id=97e90564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e90564",
  null
  
)

export default component.exports